import { Error } from '../../error';
import { Input, Select } from '../../input';

const num = (val) => (val ? parseInt(val) : null);

export const ExtractOptionsInput = ({ params, onChange, errors }) => (
  <div style={{ display: 'flex', gap: 10 }}>
    <div>
      <Input
        style={{ width: 120 }}
        label="Max extracts"
        value={params.maxExtracts}
        onChange={(e) => onChange('maxExtracts', num(e.target.value))}
        placeholder={`eg. "50"`}
      />
      <Error small message={errors?.maxExtracts} />
    </div>

    <Select
      label="Results per page"
      value={params.perPage}
      onChange={(val) => onChange('perPage', val)}
      style={{ width: 120 }}
      choices={[
        ['one', 'One'],
        ['many', 'Many'],
      ]}
    />
    <Select
      label="Extraction context"
      value={params.contentTransform}
      onChange={(val) => onChange('contentTransform', val)}
      style={{ width: 120 }}
      choices={[
        { name: 'Text only (smallest context, cheapest)', choices: [['text_only', 'Text only']] },
        { name: 'Slim HTML (text, links, and images)', choices: [['slim_html', 'Slim HTML']] },
        { name: 'Full HTML (largest context, most expensive)', choices: [['full_html', 'Full HTML']] },
        { name: 'Reduce using AI', choices: [['reduce', 'AI Reduce']] },
      ]}
    />
  </div>
);
